/**
 * Shared iOS user-agent detection.
 *
 * Every browser on iOS is WKWebView underneath, so the UA is the only
 * signal available for telling them apart. Third-party browsers keep the
 * "Safari/" token and add one of their own; bare in-app WKWebViews
 * (Gmail, Spark, Outlook) drop the token entirely.
 */

const IN_APP_TOKENS = /\b(GSA|FBAN|FBAV|Instagram|Line|Twitter|musical_ly)\b/;

// Ordered: Edge and Opera UAs also contain CriOS, so they must match first.
const IOS_BROWSERS = [
  ["EdgiOS", "Edge"],
  ["OPT/", "Opera"],
  ["FxiOS", "Firefox"],
  ["DuckDuckGo", "DuckDuckGo"],
  ["CriOS", "Chrome"],
];

export function isIos() {
  const ua = navigator.userAgent;
  return (
    /iPhone|iPad|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isIosInAppBrowser() {
  if (!isIos()) return false;
  const ua = navigator.userAgent;
  return !ua.includes("Safari/") || IN_APP_TOKENS.test(ua);
}

/**
 * Display name of the third-party iOS browser in use, or null for Safari,
 * in-app WKWebViews, and anything unrecognised.
 */
export function iosBrowserName() {
  if (!isIos() || isIosInAppBrowser()) return null;
  const ua = navigator.userAgent;
  const match = IOS_BROWSERS.find(([token]) => ua.includes(token));
  return match ? match[1] : null;
}

/**
 * Major iOS version from the UA ("OS 18_2 like Mac OS X" → 18), or null
 * when absent — notably iPadOS with "Request Desktop Website" on, which
 * presents a macOS UA.
 */
export function iosMajorVersion() {
  const match = navigator.userAgent.match(/OS (\d+)_/);
  return match ? parseInt(match[1], 10) : null;
}
